module.exports = __webpack_public_path__ + "img/04ed6bf5b780303e969fc220ebdff1d4.png";